import { Swiper } from 'swiper';
import { EffectCreative, Navigation, Pagination, Parallax } from 'swiper/modules';

class Homepage {
  private atlasSlider : Swiper[] = [];

  constructor() {
    this.init();
  }

  private init(): void {
    // Initialize homepage-specific features
    this.setupEventListeners();
    this.addTabbedGraphics();
    this.createHeroSlider();
    this.createTestimonialSwiper();
  }

  private setupEventListeners(): void {
    // Add event listeners for homepage elements

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
      this.destroySliders();
    });
  }

  private createHeroSlider(): void {
    const container = document.querySelector('.bannerSwiper') as HTMLElement;
    if (!container) return;

    const slider = new Swiper(container, {
      modules: [Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: '.bannerSwiper__button-next',
        prevEl: '.bannerSwiper__button-prev',
      },
      pagination: {
        el: '.bannerSwiper__pagination',
        clickable: true,
        dynamicBullets: false,
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
      },
      speed: 600,
      effect: 'slide',
    });

    this.atlasSlider.push(slider);
  }

  private createTestimonialSwiper(): void {
    const containers = document.querySelectorAll<HTMLElement>('.hpTestimonialSwiper');
    if (!containers.length) return;

    containers.forEach((container) => {
      if (container.classList.contains('swiper-initialized')) return;

      const prevEl = container.querySelector<HTMLElement>('.swiper-button-prev');
      const nextEl = container.querySelector<HTMLElement>('.swiper-button-next');
      const paginationEl = container.querySelector<HTMLElement>('.swiper-pagination');

      const slider = new Swiper(container, {
        modules: [EffectCreative, Navigation, Pagination, Parallax],
        grabCursor: true,
        effect: 'creative',
        creativeEffect: {
          limitProgress: 5,
          prev: { translate: ['-20%', 0, -1], shadow: true },
          next: { translate: ['100%', 0, 0], scale: 1.5, shadow: true },
        },
        speed: 600,
        navigation: prevEl && nextEl
          ? {
              enabled: true,
              prevEl,
              nextEl,
            }
          : false,
        pagination: paginationEl
          ? {
              enabled: true,
              type: 'progressbar',
              clickable: true,
              el: paginationEl,
            }
          : false,
        parallax: {
          enabled: true,
        },
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            centeredSlides: true,
            speed: 700,
          },
          1920: {
            centeredSlides: true,
            speed: 700,
          },
        },
        slidesPerGroupAuto: false,
      });

      this.atlasSlider.push(slider);
    });
  }

  private addTabbedGraphics(): void {
    const tabbedSections = document.querySelectorAll('.hp__featured-content--tabbed');
    if (!tabbedSections.length) return;

    tabbedSections.forEach(section => {
      if (section.querySelector('.tab-graphic')) return;

      const tabGraphic = document.createElement('span');
      tabGraphic.className = 'tab-graphic';
      section.appendChild(tabGraphic);
    });
  }

  private destroySliders(): void {
    this.atlasSlider.forEach(instance => {
      if(instance && typeof instance.destroy === 'function') {
        instance.destroy(true, true);
      }
    });
    this.atlasSlider = [];
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new Homepage();
});